<div class="container mt-5">
  @if (hasApiError) {
    <div class="alert alert-danger" role="alert">
      {{apiError}}
    </div>
  }

  <div class="input-group mb-3">
    <input type="text" class="form-control" placeholder="Project name" [disabled]="true" [(ngModel)]="this.jobTitle">
    <a class="geomslink" routerLink="/geometry/{{this.id}}"></a>
  </div>

  <pre>
    <!-- <code class="js rounded" [highlight]="responseJson"></code> -->

    <code class="js rounded">{{responseJson}}</code>
  </pre>

</div>